import React, { useEffect, useState } from "react";
import GlobalHelmet from "./../../GlobalHelmet";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";
import RestService from "./RestService";
import { useParams } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { Helmet } from "react-helmet";

export default function Articles() {
  let userParams = useParams();
  const article_slug = userParams?.article_slug;
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState({});
  // article_slug
  useEffect(() => {
    setLoading(true);
    RestService.getArticlesDetail(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        if (parseInt(response?.status) === 201) {
          if (response?.data?.status === 1) {
            setglobaldata(response?.data);
          }
        } else {
          setglobaldata(false);
        }
      },
      mobile,
      web_token,
      article_slug
    );
  }, [mobile, web_token, article_slug]);
  
  return (
    <>
      {loading ? <Loader /> : ""} 
      <GlobalHelmet {...Common?.Articles} />
        
       <Helmet>
        <title>{globaldata?.articleDetails?.metatitle}</title>
        <meta property="og:title" content={globaldata?.articleDetails?.metatitle}></meta>
        <meta name="description" content={globaldata?.articleDetails?.metaDescription} />
        <meta name="keywords" content={globaldata?.articleDetails?.metaKeyword} />
       </Helmet>
             

      <div className="bodycontainer">
        <div className="auto-space">
          <Breadcrumbs page="Articles" />
          <div className="signalheader">
            <div className="news-original">
              <div className="row">
                <div className="col-md-12 w3ls_mutual_funds_grid1_jkjk">
                  <div className="agileits_about_grids w3ls_products_grid">
                    <div className="agileits_about_grid">
                      <div className="col-md-12 agileits_about_grid_right"></div>

                      <div className="clearfix"> </div>
                    </div>
                  </div>
                </div>

                <div className="clearfix"> </div>
                <div className="col-md-12 w3ls_mutual_funds_grid1_jkjk">
                  <div className="row">
                    <div className="col-sm-12 my-cont pt-3 pb-2">
                      <section>
                        <div className="  py-5">
                          <div className="  text-black  ">
                            <div className="row">
                              <div className="col-sm-5">
                                <img
                                  src={globaldata?.articleDetails?.image}
                                  className="card-img-top"
                                  alt={globaldata?.articleDetails?.title}
                                />
                              </div>
                              <div className="col-sm-7">
                                <h4 className="">
                                  {globaldata?.articleDetails?.title}
                                </h4> 
                                  
                                  {
                                    ReactHtmlParser(globaldata?.articleDetails?.smallTxt)                                      
                                  } 
                              </div>
                            </div>
                            <div className="article-card-body">
                              <div className="text-muted mb-4">
                                {ReactHtmlParser(
                                  globaldata?.articleDetails?.content
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
